import tabSliderTabMeta from './block.json';
import { tabSlideIcon } from '../icons';
import { getBlockLabelByName } from '@helpers/utils.js';
import edit from './edit';
import save from './save';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = tabSliderTabMeta;

const attributes = {
  ...settings.attributes,
};

registerBlockType(name, {
  ...settings,
  icon: tabSlideIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
